import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

/** Admin-only switch to flag an assessment as test (excluded from counters). */
export default function AssessmentTestToggle({ assessmentId }) {
  const [isTest, setIsTest] = useState(null);
  const [orgTest, setOrgTest] = useState(false);
  useEffect(() => {
    api.get(`/assessments/${assessmentId}`).then(({ data }) => {
      setIsTest(!!data.is_test);
      setOrgTest(!!data.organization?.is_test);
    }).catch(() => {});
  }, [assessmentId]);
  if (isTest === null) return null;

  async function toggle(v) {
    try {
      await api.patch(`/assessments/${assessmentId}/admin-flags`, { is_test: v });
      setIsTest(v);
      toast.success(v ? "Assessment marcato come test" : "Assessment non più di test");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  }

  return (
    <label className="inline-flex items-center gap-2 text-xs text-slate-600 bg-white border border-slate-200 rounded-full px-3 py-1.5" data-testid="assessment-test-toggle">
      <Switch checked={isTest} onCheckedChange={toggle} data-testid="assessment-is-test-switch" />
      Assessment di test (escluso dai contatori)
      {orgTest && <span className="text-amber-700 font-semibold" data-testid="assessment-test-inherited">· già escluso: azienda di test</span>}
    </label>
  );
}
